import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LoginPage from './Pages/LoginPage';
import Support from './Pages/Support';
import Confirmation from './Pages/Confirmation';
import Drivers from './Pages/Drivers';
import InUser from './Pages/InUser';
import InDriver from './Pages/InDriver';
import DriverRequest from './Pages/DriverRequest';
import InConfirmation from './Pages/InConfirmation';
import InRequest from './Pages/InRequest';
import Questions from './Pages/Questions';
import EditQuestion from './editComponents/editQuestion';
import SupportMessage from './Pages/SupportMessage';
import Settings from './Pages/Settings';
import Promotions from './Pages/Promotions';
import Trips from './Pages/Trips';

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/verification",
    element: <Confirmation />,
  },
  {
    path: "/drivers",
    element: <Drivers />,
  },
  {
    path: "/user/:id",
    element: <InUser />,
  },
  {
    path: "/driver/:id",
    element: <InDriver />,
  },
  {
    path: "/requests",
    element: <DriverRequest />,
  },
  {
    path: "/userVerification/:id",
    element: <InConfirmation />,
  },
  {
    path: "/driverRequest/:id",
    element: <InRequest />,
  },
  {
    path: "/trips",
    element: <Trips />,
  },
  {
    path: "/supportMessage/:id",
    element: <SupportMessage />,
  },
  {
    path: "/FAQ",
    element: <Questions />,
  },
  {
    path: "/editFAQ/:id",
    element: <EditQuestion />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/promotions",
    element: <Promotions />,
  },
]);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
    <RouterProvider router={router} />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
